export const PLATFORM_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "mt5", label: "MetaTrader 5" },
  { value: "mt4", label: "MetaTrader 4" },
  { value: "webtrader", label: "WebTrader" },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "standard", label: "Standard" },
  { value: "premium", label: "Premium" },
  { value: "vip", label: "VIP" },
];

export const PROFESSION_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "employed", label: "Employed" },
  { value: "self-employed", label: "Self-Employed" },
  { value: "business-owner", label: "Business Owner" },
  { value: "student", label: "Student" },
  { value: "management", label: "Management" },
  { value: "unemployed", label: "Unemployed" },
  { value: "other", label: "Other" },
];

export const SOURCE_OF_FUNDS_OPTIONS = [
  { value: "", label: "Select" },
  { value: "salary", label: "Salary" },
  { value: "savings", label: "Savings" },
  { value: "pension", label: "Pension" },
  { value: "profits-dividends", label: "Profits/Dividends" },
  { value: "sale-of-assets", label: "Sale of Assets" },
  { value: "crypto-investments", label: "Crypto Investments" },
  { value: "inheritance-gifts", label: "Inheritance & Gifts" },
  { value: "other", label: "Other" },
];

export const PROOF_OF_IDENTITY_INFO = {
  intro:
    "Please provide at least ONE of the following documents that MUST have legal name, Not expired, date of birth, nationality, & registered ID number:",
  items: [
    "Passport - For any Nationality",
    "Emirates ID, in case the client is UAE Resident",
    "Any other Government Issued ID which has these credentials",
  ],
};

export const PROOF_OF_ADDRESS_INFO = {
  intro:
    "Please provide at least ONE of the following documents that MUST state current or permanent residential address as per Application form and have been issued within the last 3 calendar months",
  items: [
    "Utility Bills or statements from public utilities, including electricity, water, gas, or telephone line providers",
    "Lease / Tenancy Agreement (MUST be within the lease term)",
    "Local and national government-issued documents, including municipal tax records or similar",
    "Registered property purchase, lease or rental agreements",
    "Documents from supervised third-party financial institutions, such as bank statements or insurance policies, alike.",
    "Incase the client is sharing a bedspace or on a short term rent, may provide permenant residence document of his/her nationality.",
  ],
};
